﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederIasDto from '../Models/VeilederIasDto';
import { connect } from 'react-redux';
import { VeilederIasAppState } from '../Store';
import { toggleVilkar } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { BoksTabell } from '../../VeilederInntektsavhengigStipend/Ids';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import * as ValgTypes from '../Store/Valg/Types';
import Tabell, { Rad } from '../Models/Tabell';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import AValg from '../Utilities/A-FamiliesituasjonValg';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultOwnProps {
    valg: ValgTypes.ValgState;
    tabell: Tabell;
    eventId: string | null;
}

type TabellProps = MapStateToProps & MapDispatchToProps & ResultOwnProps;

class TabellComponent extends React.PureComponent<TabellProps> {
    constructor(props: TabellProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }
    
    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const { valg, visVilkar, epiContext, tabell, eventId } = this.props;
        const { locale, valuta } = this.props.epiContext;

        const kronerDekorasjon = valuta; //resolveRawText(epiContext, 'tabellDekorasjonKroner');
        const ellerMerDekorasjon = resolveRawText(epiContext, 'tabellDekorasjonEllerMer');

        return (
            <div id={BoksTabell} className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--white-aubergine">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--midtstilt">
                        <h3 className="c-veileder__content--header c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'overskriftTabell')}
                        </h3>
                        <div className="c-veileder__content--textarea c-veileder__content--textarea-midtstilt">
                            {contentResolver(epiContext, 'infoTabell')}
                        </div>
                    </div>
                    <div className="c-veileder__content">
                        <div role="table" className="c-table">
                            <div role="row" className="c-table__header-row">
                                <div
                                    role="columnheader"
                                    className="c-table__header-cell"
                                >
                                    {valg.aFamiliesituasjon !== undefined
                                        ? valg.aFamiliesituasjon.value === AValg.a3_enForelder
                                            ? contentResolver(epiContext, 'tabellArslonnOverskrift')
                                            : contentResolver(epiContext, 'tabellArslonnBeggeOverskrift')
                                        : null}
                                </div>
                                <div
                                    role="columnheader"
                                    className="c-table__header-cell "
                                >
                                    {contentResolver(epiContext, 'tabellStipendOverskrift')}
                                </div>
                            </div>
                            {tabell.rader
                                .sort((a, b) => (a.key > b.key ? 1 : -1))
                                .map(
                                    (rad: Rad): JSX.Element => (
                                        <div role="row" className="c-table__data-row" key={rad.key}>
                                            <div
                                                role="cell"
                                                className="c-table__data-cell"
                                            >
                                                <span>
                                                    {tilPengerFormat(rad.fra, locale)}{' '}
                                                    {rad.til !== undefined
                                                        ? ' - ' + tilPengerFormat(rad.til, locale) + ' ' + kronerDekorasjon
                                                        : ' ' + ellerMerDekorasjon}
                                                </span>
                                            </div>
                                            <div
                                                role="cell"
                                                className="c-table__data-cell"
                                            >
                                                <span>
                                                    {tilPengerFormat(rad.stipend, locale)} {kronerDekorasjon}
                                                </span>
                                            </div>
                                        </div>
                                    ),
                                )}
                            </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--bunnlenke c-veileder__content--footer">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'tabellLenketekst')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'ariaLabelTabellModal')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'overskriftTabellModal', 2)}
                                contentinnhold={contentResolver(epiContext, 'contentTabellModal', 2)}
                            />
                        </ModalCompontent>
                    </div>
                    <div className="c-veileder__content" />
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederIasDto>;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederIasAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleVilkar, updateZIndex },
)(TabellComponent);
